import React from 'react';
import { Link } from 'react-router-dom';
import { Activity, Brain, Ear, Smile, CheckCircle2, ArrowRight, Sparkles } from 'lucide-react';
import { servicesData } from '../data/mock';
import { massageCopy } from '../data/wellnessMassage';
import ClinicalSummary from './ClinicalSummary';

const iconMap = {
  Activity,
  Brain,
  Ear,
  Smile
};

const Services = () => {
  return (
    <section id="services" className="services-section">
      <div className="section-container">
        <div className="section-header">
          <h2 className="section-title">Our Specialist Services</h2>
          <p className="section-subtitle">
            Comprehensive, evidence-based treatment for TMD, headaches, migraines & tinnitus
          </p>
        </div>

        <div className="services-grid">
          {servicesData.map((service) => {
            const IconComponent = iconMap[service.icon];
            return (
              <Link 
                key={service.id} 
                to={`/services/${service.slug}`}
                className="service-card-link"
              >
                <div className="service-card">
                  <div className="service-image-wrapper">
                    <img 
                      src={service.image} 
                      alt={service.title}
                      className="service-image"
                      width="1200"
                      height="800"
                      loading="lazy"
                      decoding="async"
                      style={service.imagePosition ? { objectPosition: service.imagePosition } : undefined}
                    />
                    <div className="service-icon-overlay">
                      <div className="service-icon">
                        <IconComponent size={32} />
                      </div>
                    </div>
                  </div>
                  
                  <div className="service-content">
                    <h3 className="service-title">{service.title}</h3>
                    <p className="service-description">{service.description}</p>
                    <ClinicalSummary id={service.slug} compact />
                    
                    <ul className="service-benefits">
                      {service.benefits.map((benefit) => (
                        <li key={benefit} className="benefit-item">
                          <CheckCircle2 className="benefit-icon" size={18} />
                          <span>{benefit}</span>
                        </li>
                      ))}
                    </ul>

                    <div className="service-learn-more">
                      <span>Learn more</span>
                      <ArrowRight size={18} />
                    </div>
                  </div>
                </div>
              </Link>
            );
          })}
        </div>

        <Link
          to="/wellness-massage"
          className="wellness-teaser-card wellness-teaser-card-stealth"
          data-testid="wellness-teaser-link"
        >
          <div className="wellness-teaser-icon">
            <Sparkles size={24} />
          </div>
          <div className="wellness-teaser-body">
            <span className="wellness-teaser-eyebrow">{massageCopy.homeTile.eyebrow} · Our Signature Experience</span>
            <h3>{massageCopy.homeTile.title}</h3>
            <p data-testid="wellness-teaser-body">{massageCopy.homeTile.body}</p>
            <ClinicalSummary id="wellness-massage" compact />
          </div>
          <div className="wellness-teaser-cta" aria-hidden="true">
            <span>Discover the experience</span>
            <ArrowRight size={18} />
          </div>
        </Link>
      </div>
    </section>
  );
};

export default Services;
